module.exports = __webpack_public_path__ + "assets/img/img-hotel-08.941b68fe.jpg";